import React, { createContext, useEffect } from 'react';
import { Box, Button, Paper, Stack } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link, useHistory, useParams } from 'react-router-dom';
import { fontWeight } from '@mui/system';
import { Header } from '../../components/Header';
import { useAuth } from '../../hooks/Auth';
import { useModal } from '../../hooks/Modal';

import {
  Container,
  Content,
  Route,
  Title,
  TextSameLine,
  ColumnText
} from './styled';
import { ModalLoading } from '../../components/ModalLoading';

export const MyAccountContext = createContext({});

const MyAccount = () => {
  const { user, signInInternal, signOut } = useAuth();
  const { openModal, openedModal, closeModal } = useModal();

  const history = useHistory();

  const maxXS = useMediaQuery('(max-width:480px)');
  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const contextValues = {};

  useEffect(async () => {
    const { search } = window.location;
    const legacyToken = new URLSearchParams(search).get('token');
    const localLegacyToken = localStorage.getItem('@Braspress:legacyToken');

    if (!user || (legacyToken && legacyToken !== localLegacyToken)) {
      openModal('modalLoading');

      if (legacyToken) {
        const signInResponse = await signInInternal({ legacyToken });

        if (signInResponse === 'Invalid token') {
          window.location.href = `${process.env.REACT_APP_URL_CLIENT_VIEW}${process.env.REACT_APP_URL_BOTAO_VOLTAR}`;
        }
      } else {
        window.location.href = `${process.env.REACT_APP_URL_CLIENT_VIEW}${process.env.REACT_APP_URL_BOTAO_VOLTAR}`;
      }
    } else {
      closeModal();
    }
  }, [user]);

  return (
    <MyAccountContext.Provider value={contextValues}>
      <Container>
        {/* <Header /> */}
        {user && (
          <Content>
            <Box style={{ margin: '0 40px', paddingBottom: '40px' }}>
              {/* <Route>
                {!maxSM && (
                  <>
                    Home {'>'} Área do Cliente {'>'} Minha Conta
                  </>
                )}

                {!!user && (
                  <Stack
                    direction="row"
                    spacing={2}
                    style={{
                      alignItems: 'center',
                      marginLeft: maxSM && 'auto'
                    }}
                  >
                    <p>{user.name}</p>
                    <Button
                      type="button"
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        signOut();
                        window.location.href =
                          `${process.env.REACT_APP_URL_CLIENT_VIEW}${process.env.REACT_APP_URL_BOTAO_VOLTAR}`;
                      }}
                      size="small"
                    >
                      Sair
                    </Button>
                  </Stack>
                )}
              </Route> */}
              <h1
                style={{
                  textAlign: 'center',
                  paddingTop: '30px',
                  fontSize: '27px',
                  color: '#004e9a',
                  fontWeight: 'normal'
                }}
              >
                MINHA CONTA
              </h1>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: '#004e9a',
                  marginTop: '40px',
                  fontWeight: '500'
                }}
              >
                Olá {user.name},
                <form>
                  {/* onSubmit={handleSubmit(onNextStep)} */}
                  <Paper
                    elevation={2}
                    style={{
                      position: 'relative',
                      marginTop: 16,
                      padding: '20px 16px 16px'
                    }}
                  >
                    <Title style={{ marginBottom: 16 }}>Consulte:</Title>

                    <Stack
                      direction={maxMD ? 'column' : 'row'}
                      spacing={2}
                      style={{ marginBottom: 16 }}
                    >
                      {/* <Box> */}
                      {/* <Stack> */}
                      <TextSameLine>
                        <ColumnText>
                          <span>
                            <Link to="/acesso-rapido/tipo-de-coleta">
                              Pedido de Coleta
                            </Link>
                          </span>
                          <span>Minhas Faturas</span>
                          <span>Performance de Entrega</span>
                          <span>Atualização de Email</span>
                        </ColumnText>

                        <ColumnText>
                          <span>Cotação</span>
                          <span>Validar Faturas</span>
                          <span>Download DACTE</span>
                          <span>Prazo de Entrega</span>
                        </ColumnText>

                        <ColumnText>
                          <span>Minhas Encomendas</span>
                          <span>
                            <Link to="/area-do-cliente/minha-conta/minhas-coletas">
                              Minhas Coletas
                            </Link>
                          </span>
                          <span>Download Rota CEP</span>
                          <span>Alterar Senha</span>
                        </ColumnText>
                      </TextSameLine>
                      {/* </Stack> */}
                      {/* </Box> */}
                    </Stack>
                  </Paper>

                  {/* <StepButtons nextFunction={handleSubmit(onNextStep)} /> */}
                </form>
              </Box>
            </Box>
          </Content>
        )}
      </Container>
      {openedModal === 'modalLoading' && <ModalLoading />}
    </MyAccountContext.Provider>
  );
};

export default MyAccount;
